// ======================================================================
// File Name       : GroupUserAdminEditList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, FormControl, Row, Col, Table, Button } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import SelectBox from '../../components/SelectBox';
import Pagination from '../../components/Pagination';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';
import { RETURN_MAX_NUM } from '../../constants';
import MessageSearch from '../../components/MessageSearch';

class GroupUserAdminEditList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHideTrashIcon: false,
    };
  }

  componentWillMount() {
    const { editingUserGroupAdmin, editType } = this.props.group;
    if (editingUserGroupAdmin && editType === 1) {
      const dataUserAdmin = editingUserGroupAdmin[this.props.userInfo.userSecernId];
      if (dataUserAdmin) {
        this.setState({ isHideTrashIcon: true });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate = this.props.editingAdminGroup === nextProps.editingAdminGroup &&
      this.props.authorityBySecern === nextProps.authorityBySecern &&
      this.props.editingUserGroupAdmin === nextProps.editingUserGroupAdmin;
    return !shouldNotUpdate;
  }

  render() {
    const { authorityBySecern, editingUserGroupAdmin } = this.props;
    const editingAdminGroup = Object.keys(editingUserGroupAdmin).sort((a, b) => {
      if (editingUserGroupAdmin[a].addNew && !editingUserGroupAdmin[b].addNew) {
        return -1;
      } else if (!editingUserGroupAdmin[a].addNew && editingUserGroupAdmin[b].addNew) {
        return 1;
      }
      if (editingUserGroupAdmin[a].index < editingUserGroupAdmin[b].index) {
        return -1;
      } else if (editingUserGroupAdmin[a].index > editingUserGroupAdmin[b].index) {
        return 1;
      }
      return 0;
    });
    return (
      <div>
        <Form.Group className="form-info margin-top-50" id="scroll-table-admin">
          <Col as={Form.Label} sm={6} className="margin-top-15 padding-clear">
            所属管理ユーザー
          </Col>
          <Col sm={6} className="text-right padding-clear">
            <Button variant="default" onClick={this.props.handleRemoveAll}>ユーザ一一括削除</Button>
          </Col>
          <Col sm={12} className="padding-clear">
            <Table striped hover className="margin-top-7 margin-bottom-0">
              <thead>
                <tr>
                  <th>ユーザー名</th>
                  <th>ログインID</th>
                  <th className="col-md-1">操作</th>
                </tr>
              </thead>
              <tbody>
                {editingAdminGroup.map((userSecernId, index) => {
                  const data = editingUserGroupAdmin[userSecernId];
                  return (
                    <tr key={index} className={data.addNew ? 'background_new_record' : ''}>
                      <td>{data.userName}</td>
                      <td>{data.loginId}</td>
                      <td className="text-center">
                        {
                          userSecernId === this.props.userInfo.userSecernId ?
                            this.state.isHideTrashIcon ?
                              <i
                                role="button"
                                className="bi bi-trash"
                                onClick={this.props.handleRemoveUser.bind(null, userSecernId)}
                              />
                            :
                              <i
                                role="button"
                                className="bi bi-trash"
                                onClick={this.props.handleRemoveUser.bind(null, userSecernId)}
                              />
                          :
                              <i
                                role="button"
                                className="bi bi-trash"
                                onClick={this.props.handleRemoveUser.bind(null, userSecernId)}
                              />
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Form.Group>
        <Col sm={12} className="text-center padding-top-10">
          <Button variant="default" style={{ marginRight: '5px' }} onClick={this.props.handleBackBtn} className="btn-96">
            {'戻る'}
          </Button>
          <Button variant="primary" className="btn-96" onClick={this.props.handleNextBtn}>
            {'次へ'}
          </Button>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group, authority, authed } = state;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  return { group, authority: authority.authorityInfo, userInfo };
};
export default connect(mapStateToProps)(GroupUserAdminEditList);
